import config from './config.json';
import { NativeModules, Platform } from 'react-native';

const isWeb = Platform.OS === 'web';
const isDev = process.env.NODE_ENV === 'development';
export const isMVP = true;
const nativePackagerIP =
  !isWeb && isDev
    ? NativeModules.SourceCode.scriptURL
        .split('://')[1]
        .split('/')[0]
        .split(':')[0]
    : '127.0.0.1';
const REMOTE_API_URL = config.API_URL;
const LOCAL_API_URL = `http://${isWeb ? '127.0.0.1' : nativePackagerIP}:3001/api/v0/`;
export const API_URL = config.isLocal ? LOCAL_API_URL : REMOTE_API_URL;
export const CDN_URL = config.CDN_URL;

export const FAV_ICON = config.fav_icon;

export const DB_CONFIG = {
  apiKey: config.apiKey,
  authDomain: config.authDomain,
  databaseURL: config.databaseURL,
  projectId: config.projectId,
  storageBucket: config.storageBucket,
  messagingSenderId: config.messagingSenderId
};



// WEBPACK FOOTER //
// ./src/constants/config.js